<h3>Conferência de Importação</h3>
<p class="text-muted">
  Baixe uma relação com todos os beneficiários e seus benefícios importados até
  o momento.
</p>

<div class="loading-container" *ngIf="isLoading">
  <mat-spinner></mat-spinner>
  Carregando...
</div>

<p>
  Clicando no botão abaixo, você obterá um arquivo .xlsx com a lista de
  benefícios importados até o momento. <br />
  Com isso você consegue conferir se falta algum beneficiário ou benefício na
  importação.
</p>

<button mat-raised-button color="primary" (click)="baixarArquivo()">
  Baixar lista de benefícios
  <mat-icon>download</mat-icon>
</button>
